import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty, isNull } from 'lodash';
import { withNamespaces } from 'react-i18next';

import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import AppContainer from '../common/AppContainer';
import ApplicationSearch from './ApplicationSearch';
import on from '../../common/awaitHandler';
import elpPathService from '../../common/elpPathService';
import history from '../../common/history';
import { Constants } from '../../common/constants';
import AwsCognitoService from '../../common/awsCognitoService';
import InterstitialLoader from '../common/InterstitialLoader';
import Interstitial from '../common/Interstitial';


export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    hasError: false
  }

  constructor(props){
    super(props);

    this.handleLogIn = this.handleLogIn.bind(this);
    this.handleContext = this.handleContext.bind(this);
    this.goToForgotUsername = this.goToForgotUsername.bind(this);
    this.generateAwsInstance = this.generateAwsInstance.bind(this);
  }

  async componentDidMount() {
    const { common, commonActions } = this.props;

    if(common && isEmpty(common.tenant)){
      const tenant = elpPathService.getTenantFromPath();
      const [error, resp] = await on(commonActions.requestGetTenant({ tenant }));

      if(!error && isNull(resp)){
        history.push(Constants.path.PAGE_NOT_FOUND_PATH)
      }

      if(!error){
        await on(commonActions.requestGetAfqs({ tenantId: resp.data.id}));
      } 
    }
  }

  generateAwsInstance(){
    const { common } = this.props;
    const { tenant } = common;
    const identityProvider = tenant.identityProviderResourceList.filter(provider => provider.userType === Constants.common.END_USER)[0];

    const { mspTenantId } = tenant;
    return new AwsCognitoService(identityProvider, mspTenantId);
  }

  handleLogIn(){
    const awsCognitoService = this.generateAwsInstance();
    awsCognitoService.signIn();
  }


  handleForgotPassword = () => {
    const { tenant } = this.props.common;
    const awsCognitoService = this.generateAwsInstance();
    const { auth } = awsCognitoService;
    const URL = `https://${auth.appWebDomain}/forgotPassword?redirect_uri=${encodeURIComponent(
      auth.RedirectUriSignIn
    )}&response_type=token&client_id=${auth.clientId}&state=${tenant.mspTenantId}`;

    auth.launchUri(URL);
  };
  
  goToForgotUsername(){
    const { common } = this.props;
    const { tenant } = common;
    const { mspTenantId } = tenant;
    window.location.href=elpPathService.getConstituentForgotUsernamePath(mspTenantId)
  }

  /**
   * Allows proper functionality in the context menu when selecting open in a new tab/window
   */
  handleContext(){
    const awsCognitoService = this.generateAwsInstance();
    const url = awsCognitoService.auth.getFQDNSignIn();
    document.querySelector('#cognito-btn').setAttribute('href', url);
  }

  reloadApplicationsTable = async () => {
    const { common, commonActions } = this.props;
    return await on(commonActions.requestGetAfqs({ tenantId: common.tenant.id}));
  };

  renderTableContent = () => {
    const { common, t} = this.props;
    const { applications, requestGetAfqsPending, requestGetAfqsError } = common;

    if (requestGetAfqsPending) {
      return (
        <InterstitialLoader type="applications"/>
        )
    }

    if (!requestGetAfqsPending && !requestGetAfqsError) {
      return (
        <div className="grid-container-widescreen margin-top-4">
          <ApplicationSearch applications={applications} />
        </div>)
    }

    if(requestGetAfqsError){
      return (
        <Interstitial>
          <div className="usa-alert usa-alert--error" role="alert">
            <div className="usa-alert__body">
              <h3 className="usa-alert__heading">Error</h3>
              <p className="usa-alert__text">{t('network_error.message')}</p>
            </div>
          </div>
          <button id="refresh-applications" className="usa-button margin-top-2" onClick={this.reloadApplicationsTable}>Refresh</button>
        </Interstitial>
      );
    }
  };

  render() {
    const { common, t } = this.props;
    const { tenant } = common;
    const { mspTenantId, backgroundUrl, name  } = tenant;

    return (
      <AppContainer>
        <div className="usa-overlay" />
        <main id="main-content">
          <div className="home-default-page">
            <div className={`home-default-page__jumbotron grid-container-widescreen gray-background`} style={{backgroundImage: `url(${backgroundUrl})`}}>
               <div className="grid-row grid-gap padding-top-6 padding-bottom-6">
                 <div className="tablet:grid-col-12 margin-top-4">
                  <h1 className="home-default-page__jumbotron-title">{t('jumbotron.title')}</h1>
                  <h2 className="home-default-page__jumbo-link font-body-md">{t('jumbotron.apply_link', {tenantName: name})}</h2>
                  <p dangerouslySetInnerHTML={{__html: t( 'jumbotron.description')}}></p>
                </div>

                 <div className="grid-row grid-gap min-card">
                    <div className="grid-col-6">
                        <div className="grid-row  home-default-page__constituent-card padding-2 height-full flex-justify flex-column">
                              <div className="tablet:grid-col-12">
                                  <h2 className="margin-0">{t('account_login.title')}</h2>
                                  <p>{t('account_login.description')}</p>
                              </div>
                             
                              <div className="grid-row tablet:grid-col-12">
                                  <div className="tablet:grid-col-4">
                                  <button onClick={this.handleLogIn} className="usa-button">
                                    {t('account_login.login_btn')}
                                    </button>
                                  </div>
                                
                                  <div className="tablet:grid-col-8 display-flex flex-justify-end flex-align-center">
                                    <a  className="usa-link" href={elpPathService.getConstituentForgotUsernamePath(mspTenantId)}>
                                      {t('account_login.forgot')}
                                    </a> <span className="margin-x-05">|</span>
                                    <button className="usa-button usa-button--unstyled font-body-xs"  onClick={this.handleForgotPassword}>
                                      Forgot Password?
                                    </button>
                                  </div>
                              </div>
                              
                      </div>
                    </div>
                    <div className="grid-col-6">
                      <div className="grid-row  home-default-page__constituent-card padding-2 height-full flex-justify flex-column">
                         
                                <div className="tablet:grid-col-12 margin-bottom-4">
                                  <h2 className="margin-0">{t('constituent_card.title')}</h2>
                                  <p>{t('constituent_card.description')}</p>
                                  <div > 
                                  <Link to="/faq" className="usa-link">{t('constituent_card.cta')}</Link>
                                  </div>
                                 
                                </div>
                                <div className="grid-row tablet:grid-col-12">
                                <div className="tablet:grid-col-6">
                                  <a className="usa-link" href={elpPathService.getConstituentCreateAcctPath(mspTenantId)} className="usa-button home-default-page__login-btn">
                                    {t('constituent_card.create_btn')}
                                  </a>
                                </div>
                                <div className="tablet:grid-col-6 display-flex flex-justify-end flex-align-center">
                                  
                                  <a className="usa-link" href={elpPathService.getConstituentVerifyAcctPath(mspTenantId)}>
                                    {t('constituent_card.verify_account_link')}
                                  </a>
                                </div>
                              </div>
                         
                      </div>
                    </div>
                  </div>

               </div>
            </div>
            { this.renderTableContent() }
          </div>
        </main>
      </AppContainer>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({...commonActions}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces(['home'])(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js